import React from 'react';
import {
    LivenessStatus,
    BorrowerPosition,
    ApplicantRelationship,
    AntiFraud,
    WorthyCreditStatus
} from 'generated/graphql';

const borrowerIsNotPartnerStatuses = [
    BorrowerPosition.NotPartner,
    BorrowerPosition.Unknown,
];

const borrowerIsNotApplicantStatuses = [
    ApplicantRelationship.UnknownNonRequestingPartner,
    ApplicantRelationship.NonRequestingPartner,
];

const useAntiFraudHelper = (antiFraud: AntiFraud, borrowerPosition: BorrowerPosition) => {
    const [liveness, setLiveness] = React.useState<LivenessStatus>(LivenessStatus.Draft);
    const [worthyCredit, setWorthyCredit] = React.useState<WorthyCreditStatus>(WorthyCreditStatus.Draft);
    const [applicant, setApplicant] = React.useState<ApplicantRelationship>(null);
    const [borrower, setBorrower] = React.useState<BorrowerPosition>(null);

    React.useEffect(() => {
        if (!antiFraud) {
            return;
        }
        setLiveness(antiFraud.livenessStatus);
        setWorthyCredit(antiFraud.worthyCreditStatus);

        if (antiFraud.applicant) {
            setApplicant(antiFraud.applicant.relationship);
        }
    }, [antiFraud]);

    React.useEffect(() => {
        if (!borrowerPosition) {
            return;
        }
        setBorrower(borrowerPosition);
    }, [borrowerPosition]);

    const livenessIsDraft = () => liveness === LivenessStatus.Draft;

    const hasWorthyCreditToAnswer = () => worthyCredit === WorthyCreditStatus.Draft
        || worthyCredit === WorthyCreditStatus.Generated;

    const hasApplicant = () => applicant !== null;
    const borrowerIsPartner = () => borrower !== null && !borrowerIsNotPartnerStatuses.includes(borrower);
    const borrowerIsApplicant = () => hasApplicant() && !borrowerIsNotApplicantStatuses.includes(applicant);

    return {
        livenessIsDraft,
        hasApplicant,
        borrowerIsPartner,
        borrowerIsApplicant,
        hasWorthyCreditToAnswer
    };
};

export default useAntiFraudHelper;
